// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/delete_prop.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/delete_prop.proto.
 */
export const file_vision_shotlist_v1_delete_prop: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvZGVsZXRlX3Byb3AucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEihwEKEURlbGV0ZVByb3BSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlUHJvcFJlcXVlc3QuUGFyYW1zGi0KBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEg8KB3Byb3BfaWQYAiABKAkiZAoSRGVsZXRlUHJvcFJlc3BvbnNlEkQKBnJlc3VsdBgBIAEoCzI0LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlUHJvcFJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.shotlist.v1.DeletePropRequest
 */
export type DeletePropRequest = Message<"protos.vision.shotlist.v1.DeletePropRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeletePropRequest.Params params = 1;
   */
  params?: DeletePropRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeletePropRequest.
 * Use `create(DeletePropRequestSchema)` to create a new message.
 */
export const DeletePropRequestSchema: GenMessage<DeletePropRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_prop, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeletePropRequest.Params
 */
export type DeletePropRequest_Params = Message<"protos.vision.shotlist.v1.DeletePropRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string prop_id = 2;
   */
  propId: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeletePropRequest.Params.
 * Use `create(DeletePropRequest_ParamsSchema)` to create a new message.
 */
export const DeletePropRequest_ParamsSchema: GenMessage<DeletePropRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_prop, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeletePropResponse
 */
export type DeletePropResponse = Message<"protos.vision.shotlist.v1.DeletePropResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeletePropResponse.Result result = 1;
   */
  result?: DeletePropResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeletePropResponse.
 * Use `create(DeletePropResponseSchema)` to create a new message.
 */
export const DeletePropResponseSchema: GenMessage<DeletePropResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_prop, 1);

/**
 * @generated from message protos.vision.shotlist.v1.DeletePropResponse.Result
 */
export type DeletePropResponse_Result = Message<"protos.vision.shotlist.v1.DeletePropResponse.Result"> & {
};

/**
 * Describes the message protos.vision.shotlist.v1.DeletePropResponse.Result.
 * Use `create(DeletePropResponse_ResultSchema)` to create a new message.
 */
export const DeletePropResponse_ResultSchema: GenMessage<DeletePropResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_prop, 1, 0);

